"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconScorchDamageFilled = function IconScorchDamageFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M26,8a3,3,0,0,1,3,3V28.59l.89.59a7,7,0,1,1-7.78,0l.89-.59V11a3,3,0,0,1,3-3m0-2a5,5,0,0,0-5,5V27.52a9,9,0,1,0,10,0V11a5,5,0,0,0-5-5Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27,30.1V12H25V30.1a5,5,0,1,0,2,0Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.21,32.84a7.19,7.19,0,0,1-2.88-1.17C10.67,30.5,9,28.33,9,24.33s4-6.66,4-6.66v2A1.3,1.3,0,0,0,14.33,21c1.77,0,1.34-2.67,1.34-4a11.34,11.34,0,0,1,.66-4.67A6,6,0,0,1,19.1,9.85,6.23,6.23,0,0,0,19,11V26.52A11,11,0,0,0,15.21,32.84Z",
    fill: color
  }));
};

IconScorchDamageFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconScorchDamageFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconScorchDamageFilled;
exports.default = _default;